import { ButtonIcon } from 'controller/components/ButtonIcon';
import * as React from 'react';
import styled from 'styled-components';

interface Props {
  muted: boolean | undefined;
  playing: boolean;
  onToggleMuted: () => void;
  onTogglePlayback: () => void;
  onEdit: () => void;
}

const Wrapper = styled.div`
  position: absolute;
  background: white;
  border-radius: 999px;
  bottom: 37px;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);

  display: flex;
  gap: 8px;

  button.icon {
    width: 56px;
    height: 56px;

    .img {
      transform: scale(1.2);
    }
  }

  button.icon.icon--edit {
    .img {
      background-color: var(--accent-color);
      // transform: scale(1);
    }
  }
`;

export const FloatingControls: React.FC<Props> = props => {
  const { muted, playing, onToggleMuted, onTogglePlayback, onEdit } = props;
  return (
    <Wrapper>
      {muted !== undefined && (
        <ButtonIcon icon={muted ? 'unmute' : 'mute'} onClick={onToggleMuted} />
      )}
      <ButtonIcon
        icon={playing ? 'pause' : 'play'}
        onClick={onTogglePlayback}
      />
      <ButtonIcon icon="edit" onClick={onEdit} />
    </Wrapper>
  );
};



// WEBPACK FOOTER //
// ./src/showcase/FloatingControls.tsx